import React, { useEffect, useState } from "react";
import CustomDrawer from "../../controls/CustomDrawer";
import Button from "../../controls/Button";
import Input from "../../controls/Input";
import ImageUpload from "../../controls/ImageUpload";
import CustomSwitch from "../../controls/CustomSwitch";
import ColorPicker from "../../controls/ColorPicker";
import { uploadImagesToServer } from "../../../../uploadImageToServer"
import Loading from "../../controls/Loading";
import {
  handleAddCategory,
  handleEditCategory,
} from "../../../api/CategoryApi";
import { toast } from "react-toastify";
import CustomToast from "../../controls/CustomToast";

const AddCategory = ({
  closeDrawer,
  onSave,
  editData,
}) => {
  // Local state for form fields
  const [imageData, setImageData] = useState(null);
  const [selectedColor, setSelectedColor] = useState("#ffffff");
  const [OMNIEnabled, setOMNIEnabled] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [sequence, setSequence] = useState(0);
  const [nameError, setNameError] = useState("");
  const [loading, setLoading] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);
  const [imageFileName, setImageFileName] = useState("");
  const [imageFileSize, setImageFileSize] = useState(0);
  const [showToast, setShowToast] = useState(false);



  // When 'data' changes (i.e. when editing), update the form values.
  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      setCategoryName(editData.Name || "");
      setSequence(editData.Sequence || 0);
      setSelectedColor(editData.Color || "#ffffff");
      // Adjust according to your API: editData.ManualRun (boolean) or editData.online ("Yes"/"No")
      setOMNIEnabled(editData.OMNIEnabled);
      setImageData(editData.Image?.Preview || null);
      setImageFileName(editData.Image?.Name || "");
      setImageFileSize(editData.Image?.size || 0);
    } else {
      // Reset to defaults if creating a new category.
      setCategoryName("");
      setSequence(0);
      setSelectedColor("#ffffff");
      setOMNIEnabled(false);
      setImageData(null);
    }
    // Clear any previous error message when data changes.
    setNameError("");
  }, [editData]);

  const handleImageUpload = async (image) => {
    setImageUploading(true)
    const uploadurl = await uploadImagesToServer(image);
    console.log("uploadurl kay he ", uploadurl)
    if (uploadurl) {
      setImageData(uploadurl);
      setImageUploading(false); // Upload hone ke baad false kar diya

    }
  };

  const handleColorChange = (color) => {
    setSelectedColor(color);
  };

  const handleSaveClick = async () => {
    // Validate that the category name is not empty.
    if(imageUploading){
      toast.info("Please wait for uploading image then try...!");
      return;
    }
    if (categoryName.trim() === "") {
      setNameError("please provide category name");
      return;
    }

    let responseData = "";
    setLoading(true);
    // Build the payload
     let omniTag = '';
     omniTag = categoryName.replace(/[@!&\/\\#,+()$~%.'"`_:*?<>{}-]/g, '').replace(/ /g,"_")
    const payload = {
      Color: selectedColor,
      Sequence: Number(sequence),
      Name: categoryName.trim(),
      Image: {
        Preview: imageData,
        Name: imageFileName,
        size: imageFileSize
      },
      IsDeleted:false,
      OMNITag:omniTag,
            BackEndUpdate: false ,
            OMNIEnabled:OMNIEnabled,
      ...(editData?.key && { key: editData.key }),
    };
    console.log("payloaddata--", payload)
   

  

    setLoading(true);
    try {
      let response = null;
    
      if (editData?.key) {
        response = await handleEditCategory(payload);
      } else {
        response = await handleAddCategory(payload);
      }
    
      if (response?.code === "0") {
        toast.success(
          editData?.key 
            ? "Category updated successfully" 
            : "Category added successfully"
        );
       
        closeDrawer(false);
        onSave(response?.category);
      } else {
        const errorMessage = response?.data?.message || "Failed to save category";
        console.error("Failed to save category:", errorMessage, response);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Runtime error while saving category:", error);
      toast.error(
        error.response?.data?.message || 
        error.message || 
        "An unexpected error occurred"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setVisible(false);
    if (onClose) onClose(); // Call onClose when toast closes
  };
  return (
    <>
      <CustomDrawer
        buttons={[
          { Label: "Cancel", Type: "secondary", Icon: "roundedRemove" },
          { Label: "Save", Type: "primary", Icon: "save" },

        ]}
        onButtonClick={(label) => {
          if (label === "Save") {
            handleSaveClick();
          } else if (label === "Cancel") {
            setShowToast(true);
           
          }
        }}
        setDrawer={closeDrawer}
        title={
          editData && Object.keys(editData).length > 0
            ? "Edit Category"
            : "New Category"
        }
        drawerType="medium"
      >
        {/* The key on this container forces a re‑mount when switching between records */}
        {loading ? <div className="z-100"> <Loading /></div> :
          <div
            className="flex flex-col gap-4"
            key={editData && editData.key ? editData.key : "new"}
          >
            <Input
              isMandatory={true}
              label="Category Name"
              placeholder="Category Name"
              value={categoryName}
              onChange={(e) => {
                setCategoryName(e.target.value);
                if (e.target.value.trim() !== "") {
                  setNameError("");
                }
              }}
              errorMessage={nameError}
            />
            <div className="w-[50%]">
              <Input
                label="Sequence"
                placeholder="Sequence"
                type="number"
                value={sequence}
                onChange={(e) => setSequence(e.target.value)}
              />
            </div>


            {imageUploading ? <p>Uploading...</p> :
              <ImageUpload
                onImagedelete={() => {
                  setImageData(null);
                  setImageFileName("");
                  setImageFileSize(0);
                }}
                onImageChange={handleImageUpload}
                imageData={imageData}
                onFileInfoChange={(fileInfo) => {
                  if (fileInfo) {
                    setImageFileName(fileInfo.name);
                    setImageFileSize(fileInfo.size);
                  } else {
                    setImageFileName("");
                    setImageFileSize(0);
                  }
                }}
              />
            }

            <ColorPicker value={selectedColor} onChange={handleColorChange} />

            <CustomSwitch
              formlabel="Show Online"
              checked={OMNIEnabled}
              onChange={(checked) => setOMNIEnabled(checked)}
            />
          </div>}
      </CustomDrawer >

      {showToast && (
  <CustomToast
    type="success"
    message={"If you leave, your unsaved changes will be discarded."}
    primaryBtnText="Continue"
    secondaryBtnText="Cancel"
    onPrimaryClick={() => {
      closeDrawer(false);
      setShowToast(false); // Reset state
    }}
    onSecondaryClick={() => {
      setShowToast(false); // Reset state
    }}
    onClose={() => {
      setShowToast(false); // Reset state when toast closes automatically
    }}
  />
)}

    </>
  );
};

export default AddCategory;